// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../../shared/action-creators/busy-counter';
import {deleteFile as deleteFileRepo, getFiles as getFileRepo} from '../../../../product/shared/repositories';
import actions from '../action-list';

export const deleteFile = fileToDelete =>
    async (dispatch, getState) => {

        const doesFileExist = getState().claims.massChannelPdi.claim.file.some(item => item.fileName === fileToDelete.fileName && item.serialNumber === fileToDelete.serialNumber);

        if (doesFileExist) {

            dispatch(busyCounter.increaseBusyCounter());

            try {

                await deleteFileRepo(fileToDelete);

                dispatch({
                    data: fileToDelete,
                    type: actions.DELETE_CLAIM_MASS_CHANNEL_PDI_FILE
                });

                const files = await getFileRepo(fileToDelete);

                dispatch({
                    files,
                    type: actions.UPDATE_CLAIM_MASS_CHANNEL_PDI_FILE
                });

            } catch (error) {

            } finally {

                dispatch(busyCounter.decreaseBusyCounter());

            }

        }

    };

export const addFile = data => ({
    data,
    type: actions.ADD_CLAIM_MASS_CHANNEL_PDI_FILE
});



// WEBPACK FOOTER //
// ./src/claim/marketing/mass-channel-pdi/action-creators/file-attachment.js